import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import DocumentRow from './DocumentRow';

type AddBoardsDocumentSectionBodyProps = {
  files: File[];
  handleRemoveFile: (index: number) => void; // eslint-disable-line
};

const AddBoardsDocumentSectionBody: FC<AddBoardsDocumentSectionBodyProps> = ({
  files,
  handleRemoveFile,
}) => {
  const { t } = useTranslate();

  return (
    files?.length > 0 && (
      <div className="card-borderer col-12 pt-0">
        <div className="nk-files nk-files-view-list">
          <div className="nk-files-head">
            <div className="nk-file-item">
              <div className="nk-file-info">
                <div className="tb-head ml-4">{t('Name')}</div>
              </div>

              <div className="nk-file-meta d-none d-xl-table-cell text-center">
                <div className="tb-head">{t('DocumentDate')}</div>
              </div>
            </div>
          </div>
          <div className="nk-files-list">
            {files?.map((file: File, index: number) => (
              <DocumentRow
                key={index} // eslint-disable-line react/no-array-index-key
                index={index}
                file={file}
                handleRemoveFile={handleRemoveFile}
              />
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default AddBoardsDocumentSectionBody;
